<capra-toast
  class="error-toast"
  type="error"
  [showCloseBtn]="true"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
  <h4 class="toast-header">Publication failed</h4>
  <p class="toast-text">
    This can happen when the underlying data is incompatible, or its size exceeds your Workspace’s data compute plan.
  </p>
</capra-toast>
